import { ChangeDetectorRef, Component, HostListener, Inject, LOCALE_ID, ViewEncapsulation } from '@angular/core';
import { UiKitModule } from '../../shared/modules/ui-kit/ui-kit.module';
import { CommonNgModule } from '../../shared/modules/common-ng/common-ng.module';
import { CommonModule, Location, registerLocaleData } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UtilsService } from '../../services/utils.service';
import { validate, clean, format, getCheckDigit } from 'rut.js';
import { PrimeModuleModule } from '../../shared/modules/prime-module/prime-module.module';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { HTTP_INTERCEPTORS, HttpEventType, HttpResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RecaptchaVerifyService } from '../../services/recaptcha-verify.service';
import { NotificationService } from '../../services/notification.service';
import { MessageService } from 'primeng/api';
import { ConsultaService } from '../../services/consulta.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptionService } from '../../services/encryption.service';

import { gsap } from "gsap";    
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ProgressBarStepperPeriodosRestitucionComponent } from '../../ui-kit/organisms/progress-bar-stepper-periodos-restitucion/progress-bar-stepper-periodos-restitucion.component';
import { TabMenuRestitucionComponent } from '../../ui-kit/organisms/tab-menu-restitucion/tab-menu-restitucion.component';
import { TabViewComponent } from '../../ui-kit/atoms/tab-view/tab-view.component';
import { RestitucionService } from '../../services/restitucion.service';
import { DetalleDeMovimientosComponent } from '../../ui-kit/organisms/detalle-de-movimientos/detalle-de-movimientos.component';
import { CartolaDeMovimientosComponent } from '../../ui-kit/organisms/cartola-de-movimientos/cartola-de-movimientos.component';
gsap.registerPlugin(ScrollToPlugin)
import localeEs from '@angular/common/locales/es';
import { ModalComponent } from '../../ui-kit/organisms/modal/modal.component';
import { ModalMessageService } from '../../services/modal-message.service';
import { ProntoPagoComponent, PasoProntoPago } from '../pronto-pago/pronto-pago.component';
import { BannerProntoPagoComponent, ContenidoBannerProntoPago } from '../../ui-kit/organisms/banner-pronto-pago/banner-pronto-pago.component';
import { ProntoPagoRestitucionService, ProntoPagoResumen } from '../../services/pronto-pago-restitucion.service';

@Component({
  selector: 'app-home',
  standalone: true,
  
  providers:[
    UtilsService,
    NotificationService,
    RecaptchaVerifyService,
    MessageService,
    ConsultaService,
    RestitucionService,
    EncryptionService,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptcha.siteKeyV3,
    },
    { provide: LOCALE_ID, useValue: 'es' }
  ],
  imports: [
    CommonModule,
    CommonNgModule,
    UiKitModule,
    PrimeModuleModule,
    RecaptchaV3Module,
    ProgressBarStepperPeriodosRestitucionComponent,
    TabMenuRestitucionComponent,
    TabViewComponent,
    DetalleDeMovimientosComponent,
    CartolaDeMovimientosComponent,
    ProntoPagoComponent,
    BannerProntoPagoComponent,
    // ModalComponent
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class HomeComponent {
  formData!: FormGroup;
  verifyRutCampo: boolean     = false;
  verifyDctoCampo: boolean     = false;
  submitted: boolean          = false;
  filterRut:any =  'num';
  recaptchaV2Response!: any;
  loading: boolean = false;
  resultsConsulta:any = [];
  paramsFromApplication:any;
  disabledBtn:boolean = false;
  nuevaConsulta:boolean = false;
  validacionUser:boolean = false;
  step:any = null;
  typeApp:any = undefined;
  activeBreadCrumbs:boolean = false;
  activeHead:boolean = false;
  textBienvenido:any = '';
  textBienvenidoLink:any = '';
  dataTabMenu:any = [];
  tabView_index: any = 10;
  viewTabMenuRestitucion:boolean = false;
  excedente:any;
  infoRetiro:any;
  detalleVencimiento:boolean = true;
  ResumenExcedentes:any = [];
  resumenMovimientosRest:any = [];
  resumenCta:any;
  currentRutUser:any;
  viewDetalle:boolean = false;
  viewBanneer:boolean = false;
  themeTabMenu:any = 'tab-menu-restitucion';
  viewModal:boolean = false;
  tituloModal:any;
  modalCustomIcon:any;
  parrafoModal: any;
  accionCerrarModal: any;
  idApp: any;
  opcion: any;
  rut: any;
  data:any;
  devolucionMasivaResp:any = [];
  viewDevolucionMasiva:boolean = false;
  mostrarBannerProntoPago: boolean = false;
  pasoInicialProntoPago: PasoProntoPago = 'propuesta';
  contentBannerProntoPago: ContenidoBannerProntoPago = {
    chip: 'Tienes una oferta disponible',
    title: 'Pago Anticipado “Pronto Pago”',
    body: 'Adelanta el pago de tu saldo pendiente por restitución y recíbelo ahora.',
    cta: 'Ver propuesta',
    aceptaOferta: false
  };

  verifyRecaptcha = (response: any) => {
    if (response.length > 0) {
      this.submitted = true;
      this.recaptchaV2Response = response;
      this.getResponseForm();
      setTimeout(() => {
        grecaptcha.reset();
      }, 120);
    }
  };

  private minLengthRut = 7;
  @HostListener('input', ['$event'])
  onInput(event: Event) {
      const input = event.target as HTMLInputElement;
      let value = input.value.trim();
      if (value.length >= this.minLengthRut) {
      this.filterRut = 'alphanum';
      } else if (value.length < this.minLengthRut) {
      this.filterRut = 'num';
      }
  }


  onRutInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value.trim();

    this.filterRut = value.length >= this.minLengthRut ? 'alphanum' : 'num';
  }


  constructor(
    @Inject(NotificationService)
    private notificationService: NotificationService,
    private fb: FormBuilder,
    private readonly utilsService: UtilsService,
    private readonly recaptchaVerifyService: RecaptchaVerifyService,
    private readonly consultaService: ConsultaService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private _location: Location,
    private restitucionService: RestitucionService,
    private ref: ChangeDetectorRef,
    private encryptionService: EncryptionService,
    public modalMessageService: ModalMessageService,
    private readonly prontoPagoService: ProntoPagoRestitucionService
  ){
    registerLocaleData(localeEs);
    this.formData = this.fb.group({
      username: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
      nDocumento: ['', [Validators.required, Validators.minLength(7), Validators.maxLength(10)]],
    });

    const base64EncodedQueryString:any = this.activatedRoute.snapshot.paramMap.get('qs');

    if (!base64EncodedQueryString) {
      // Sin :qs (ej. entrando por path '') se asume Sitio Privado (SA)
      this.idApp = '0';
    } else {
      try {
        const encodedQueryString = atob(base64EncodedQueryString);
        const decodedQueryString:any = encodedQueryString;//encryptionService.decryptData(encodedQueryString);
        const params = new URLSearchParams(decodedQueryString);
        this.idApp = params.get('idApp'); // "3"
        this.opcion = params.get('opcion'); // "mov"
        this.rut = params.get('rut'); // "123"
        this.data = params.get('data');

        if(this.data!= null) {
          let textoSinSaltos = this.data.replace(/\\r/g, "");
          sessionStorage.setItem('segurito', btoa(textoSinSaltos));
        }

      } catch (error) {
        this.modalMessageService.openModal(
          '¡Ups!',
          'No se pudo cargar la consulta, por favor intenta más tarde',
          false,
          false
        );
        this.nuevaConsulta = true;
      }
    }
    
    this.dataTabMenu = [
      { id: 0, label: 'validación rut', active: true, disabled: false, viewMenu: false},
      { id: 1, label: 'Plan de pago', active: true, disabled: false, viewMenu: true},
      { id: 2, label: 'Devolución masiva', active: false, disabled: false, viewMenu: false},
      { id: 3, label: 'Resumen de movimientos', active: false, disabled: false, viewMenu: true},
      { id: 4, label: 'Cartola de movimientos', active: false, disabled: false, viewMenu: false},
      { id: 5, label: 'Pronto Pago', active: false, disabled: false, viewMenu: false}
    ];

    this.infoRetiro = {
      saldoContable: 0,
      fechaSaldoContable: '20/12/2012',
      saldoUsado: 2000,
      saldoAPagar: 10000,
      fechaCopago: '20/12/2011',
      fechaPago: '20/12/2011',
      tipoPago: 'Credito',
      banco: 'Santander',
      cuenta: '0093002',
      fechaVencimientoValeVista: '20/12/2011',
      estadoDePago: 'Pendiente'
    }

    this.excedente = {
      fechaApertura: 1731514948,
      detalleMovimiento: 30203,
      totalAbonos: 290000,
    };

    this.ResumenExcedentes = [
      {
        id:0,
        detalleMovimiento: 'cobro',
        totalAbonos: 32323232,
        totalCargos: 8728328
      }
    ]
    
    if( this.idApp ) {
      this.configuracionContextApp(this.idApp, this.opcion, this.rut);
    }else {
      window.location.href='https://www.colmena.cl';
    }

  }

  // ngOnInit(){}

  get f() { return this.formData.controls; }
  
  verifyRut() {
    const { formattedRut, isValid } = this.utilsService.verifyRut(this.formData?.controls['username']?.value);
    // console.log('formattedRut', formattedRut);
    this.formData?.controls['username']?.setValue(formattedRut);
    this.verifyRutCampo = !isValid;
  }

  verifyNDocumento(){
    this.verifyDctoCampo = this.formData?.controls['nDocumento']?.value.length < 7;
  }
  
  onSubmit(){
    this.submitted = true;
    if (this.formData.valid) {
      this.loading = true;
      this.disabledBtn = true;
      this.crearSolicitud();
    }
  }

  getResponseForm() {
    this.validacionIdentidad();
    gsap.to(window, { duration: 1, scrollTo: 0, delay: 2 });
  }

  executeRecaptchav2() {
    // this.disabledBtn = true;
    document.getElementById("recaptcha2")!.style.display = "block";
    grecaptcha.ready(() => {
      grecaptcha.render('recaptcha2', {
        'sitekey': environment.recaptcha.siteKeyV2,
        //'size': 'invisible',
        'callback': this.verifyRecaptcha
      });
    });
  }

 
  crearSolicitud() {
    grecaptcha.ready(() => {
      grecaptcha.execute(environment.recaptcha.siteKeyV3, { action: 'contacto' }).then((token) => {
        this.recaptchaVerifyService.verifyRecaptchaCode(token).subscribe(resp => {
          // resp.score = 0.1; // Forzar para ejecutar Recaptcha 2
          if (resp.success && resp.score >= 0.5) {
            this.validacionIdentidad();
          } else {
            this.executeRecaptchav2();
          }
        });
      });
    });
   
  }

  validacionIdentidad(){
    const payload:any = {
      "documentNumber": this.formData.controls['username'].value,
      "documentSerialNumber": this.formData.controls['nDocumento'].value
    }
    this.consultaService.validacionIdentidad(payload)
    .subscribe({
      next: (response) => {
        if(response.codigoRetorno == 0) {
          this.validacionRestitucion();
        } else {
          this.modalMessageService.openModal(
            '¡Lo sentimos!',
            response.glosaRetorno,
            false,
            false
          );
          this.nuevaConsulta = true;
        }      
      },
      error: (error) => {
        this.modalMessageService.openModal(
          '¡Ups!',
          error,
          false,
          false
        );
        this.nuevaConsulta = true;
      }
  })
  }

  validacionRestitucion() {
    this.consultaService.validacionRestitucion()
    .subscribe({
      next: (response) => {
        // console.log('response', response);
        // this.step = 0;
        // response.codigoRetorno = 2;
        switch (response.codigoRetorno) {
          case 0: // Es afiliado y es candidato a restitución
          window.open('https://www.colmena.cl/afiliados/#/login', '_blank');
          this.viewTabMenuRestitucion = false;
          break; 
          case 1: // es afiliado pero no es candidato a restitución
            window.open('https://www.colmena.cl/afiliados/#/login', '_blank');
            this.viewTabMenuRestitucion = false;
          break;
          case 2: // No es afiliado pero si es candidato a restitución.
          this.viewTabMenuRestitucion = true;
          this.resumenMovimientosRestitucion();
          this.devolucionMasiva();
          this.resumenCuentaRestitucion();
          this.tabView_index = 1;
          this.currentRutUser =  this.formData.controls['username'].value;
          this.evaluarProntoPago();
            // Si no es afiliado, debe mostrar pantalla de plan de pago y todas las categorias correspondientes
          break;
          case 3: // no es afiliado y tampoco es candidato a restitución.
            // Si no es afiliado, debe mostrar un mensaje claro indicando que no cumple con los requisitos para la restitución.
            // this.notificationService.error('Ups!', 'No eres afiliado y no cumples con los requesitos para el proceso.');
            this.openModal('no-afiliado-no-candidato', null);
            this.viewTabMenuRestitucion = false;
            
          break;
          case 4: // no pasa validación Equifax
          this.viewTabMenuRestitucion = false;
          // this.notificationService.error('Ups!', 'No pudimos validar tus datos, espera e intentalo de nuevo.');
          this.openModal('no-validar-datos', null);
          // setTimeout(() => {
          //   this.refreshPage();
          // }, 6000);
          break;
        }

        this.loading = false;


        // if (response) {
        //  this.validacionUser = response; 
        // } else if ( response === undefined || response === null ) {
        //     this.notificationService.error('Ups!', 'Error al crear la validación');
        // }
        // // this.notificationService.success('Perfecto !', 'puedes revisar los datos de tú solicitud');
        // this.nuevaConsulta = true;
      },
      error: (error) => {
        this.modalMessageService.openModal(
          '¡Ups!',
          error,
          false,
          false
        );
        this.nuevaConsulta = true;
      }
  })
  }

  consultarRut(){
     const payload:any = {
      "documentNumber": this.formData.controls['username'].value,
      "documentSerialNumber": this.formData.controls['nDocumento'].value
    }
    // console.log('payload', payload);
    this.consultaService.consultaRestitucion()
      .subscribe({
        next: (response) => {
          // console.log('Respuesta del servidor:', response);
          this.resultsConsulta = response;
          this.openModal('revisar-datos', null);
          this.nuevaConsulta = true;
        },
        error: (error) => {
          this.openModal('error', error);
          this.nuevaConsulta = true;
        }
    });
  }

  refreshPage(){
    window.location.reload();
  }

  configuracionContextApp(idApp:any, opcion:any, rut:any){
    this.typeApp = idApp;
    // console.log('configuracionContextApp', {
    //   'idApp': idApp,
    //   'opcion': opcion,
    //   'rut': rut
    // });
    switch (idApp) {
      case '0': // Sitio Privado
        this.activeBreadCrumbs = false;
        this.activeHead = false;
        this.textBienvenido = 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
      break;
      case '1':
        this.dataTabMenu[2].viewMenu = false;
         this.dataTabMenu[4].viewMenu = false;
        this.activeBreadCrumbs = true;
        this.activeHead = true;
        this.textBienvenido= 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        if(this.tabView_index != 0 && this.tabView_index != 10) {
          this.viewBanneer = true;
        }
      break;
      case '2': // App
        this.activeBreadCrumbs = true;
        this.activeHead = false;
        this.textBienvenido = 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
      break;
      case '3': // Consulta Integral
        this.activeBreadCrumbs = true;
        this.activeHead = true;
        this.textBienvenido= 'De acuerdo a la Normativa Ley N° 21.674, ponemos a su disposición la consulta de Excedentes de Restitución por fallo, en cual usted podrá revisar su situación particular.';
        if (opcion === 'plan') { //Plan
          this.themeTabMenu = 'tab-menu-restitucion oneTab';
          // alert('PLAN DE PAGO');
          this.dataTabMenu[0].viewMenu = false;
          this.dataTabMenu[1].viewMenu = true;
          this.dataTabMenu[2].viewMenu = false;
          this.dataTabMenu[3].viewMenu = false;
          this.dataTabMenu[4].viewMenu = false;
          // this.tabView_index = 1;
         
        }else if (opcion === 'mov') { // Movimientos
          // alert('MOVIMIENTOS');
          this.themeTabMenu = 'tab-menu-restitucion oneTab';
          this.formData?.controls['username']?.setValue(rut);
          this.resumenMovimientosRestitucion();
          this.resumenCuentaRestitucion();
          this.currentRutUser =  this.formData.controls['username'].value;
          this.dataTabMenu[0].viewMenu  = false;
          this.dataTabMenu[1].viewMenu  = false;
          this.dataTabMenu[2].viewMenu  = false;
          this.dataTabMenu[3].active    = true;
          this.dataTabMenu[3].viewMenu = true;
          this.dataTabMenu[4].viewMenu = false;
          this.viewTabMenuRestitucion = true;
          this.tabView_index = 3;
        }else if (opcion === 'dev') { // Devolución
          this.themeTabMenu = 'tab-menu-restitucion oneTab';
          this.formData?.controls['username']?.setValue(rut);
          this.devolucionMasiva();
          this.currentRutUser =  this.formData.controls['username'].value;
          this.dataTabMenu[0].viewMenu  = false;
          this.dataTabMenu[1].viewMenu  = false;
          this.dataTabMenu[3].viewMenu  = false;
          this.dataTabMenu[4].viewMenu  = false;
          this.dataTabMenu[2].viewMenu  = true;
          this.dataTabMenu[2].active    = true;
          this.viewTabMenuRestitucion = true;
          this.tabView_index = 2;
        }
        this.viewBanneer = false;
      break;
    }
  }

  goToLink(){
    window.open('https://www.colmena.cl/', '_blank');
  }


  getTabViewSelected($event:any) {
    // console.log('$event', $event);
    this.tabView_index = $event.item['id'];
    if(this.tabView_index != 0) {
      this.viewBanneer = true;
    }else if (this.tabView_index === 0) {
      this.viewBanneer = false;
    }
  }

  verDetalleMovimientos(){
    this.viewDetalle = true;
  }

  backClicked() {
    this._location.back();
  }


  resumenCuentaRestitucion() {
    this.restitucionService.resumenCuentaRestitucion().subscribe( (resumenCta:any) => {
      if(resumenCta) {
        this.resumenCta = resumenCta;
      }
    });
  }

  resumenMovimientosRestitucion(){
    this.restitucionService.resumenMovimientosRestitucion().subscribe( (resumenMovimientos:any) => {
      // console.log('resumenMovimientos', resumenMovimientos);
      if(resumenMovimientos) {
        this.resumenMovimientosRest = resumenMovimientos;
      }
    });
  }

  devolucionMasiva(){
    // this.formData.controls['username'].value
    // console.log('username*******', this.formData.controls['username'].value)
    this.restitucionService.devolucionMasiva().subscribe( (devolucionMasiva:any) => {
      // console.log('devolucionMasiva::', devolucionMasiva);
      // devolucionMasiva.code = 1;
      if(devolucionMasiva.code === 0) {
        this.devolucionMasivaResp = devolucionMasiva.response;
        this.viewDevolucionMasiva = true;
        this.dataTabMenu[2].viewMenu = true;
      }else {
        this.viewDevolucionMasiva = false;
        this.dataTabMenu[2].viewMenu = false;
      }
    });
  }


  openModal(context:any, error:any){
    switch (context) {
      case 'no-afiliado-no-candidato':
        this.modalMessageService.openModal(
          '¡Lo sentimos!',
          'No reúnes las condiciones necesarias para acceder al proceso de restitución de excedentes bajo la Ley N° 21.674.',
          false,
          false
        );
        setTimeout(() => {
          this.refreshPage();
        }, 12000);
      break;
      case 'no-validar-datos':
        this.modalMessageService.openModal(
          '¡Lo sentimos!',
          'No hemos podido verificar tu identidad con los datos recibidos. Por favor revísalos e intenta nuevamente',
          false,
          false
        );
      break;
      case 'error':
        this.modalMessageService.openModal(
          '¡Ups!',
          'Ha ocurrido un error inesperado. Por favor, intente nuevamente más tarde.',
          false,
          false
        );
      break;
      case 'revisar-datos':
        this.modalMessageService.openModal(
          '¡Perfecto!',
          'Puedes revisar los datos de tú solicitud',
          false,
          false
        );
      break;
    }
    this.viewModal = true;
  }

  cerrarModal($event:any){
    // console.log('cerrarModal', $event);
    this.viewModal = false;
    // this.refreshPage();
  }

  // --- Pronto Pago ---------------------------------------------------------

  private evaluarProntoPago(): void {
    if (!environment.featureFlags || !environment.featureFlags.prontoPagoRestitucion) {
      return;
    }

    this.prontoPagoService.getResumen().subscribe({
      next: (resumen) => this.aplicarOfertaProntoPago(resumen),
      error: () => { /* Sin oferta: el portal sigue exactamente como hoy. */ }
    });
  }

  private aplicarOfertaProntoPago(resumen: ProntoPagoResumen): void {
    const aceptaOferta = !!(resumen && resumen.aceptaOferta);
    const ofertaVigente = !!(resumen && resumen.ofertaVigente && resumen.campanaVigente);

    if (!aceptaOferta && !ofertaVigente) {
      return;
    }

    this.pasoInicialProntoPago = aceptaOferta ? 'resultado' : 'propuesta';
    this.contentBannerProntoPago = this.armarContenidoBanner(resumen, aceptaOferta);
    this.dataTabMenu[5].viewMenu = true;
    this.mostrarBannerProntoPago = true;
    this.ref.detectChanges();
  }

  private armarContenidoBanner(resumen: ProntoPagoResumen, aceptaOferta: boolean): ContenidoBannerProntoPago {
    if (aceptaOferta) {
      return {
        chip: 'Solicitud registrada',
        title: '¡Tu oferta de Pronto Pago fue aceptada!',
        body: 'Puedes revisar el detalle de tu propuesta y el estado de tu pago.',
        cta: 'Ver mi solicitud',
        aceptaOferta: true
      };
    }

    const uf = resumen.liquidoSinCompensacionUf;
    const pesos = resumen.liquidoSinCompensacionPesos;
    const body = (uf && pesos)
      ? `Adelanta el pago de tu saldo pendiente y recibe <b>${this.formatearUf(uf)} UF</b> (≈ ${this.formatearPesos(pesos)}) ahora. También puedes usarlo para <b>compensar tu deuda</b>.`
      : 'Adelanta el pago de tu saldo pendiente por restitución y recíbelo ahora.';

    return {
      chip: 'Tienes una oferta disponible',
      title: 'Pago Anticipado “Pronto Pago”',
      body,
      cta: 'Ver propuesta',
      aceptaOferta: false
    };
  }

  private formatearUf(valor: number): string {
    return new Intl.NumberFormat('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 20 }).format(valor);
  }

  private formatearPesos(valor: number): string {
    return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(valor);
  }

  /** Abre la pestaña de Pronto Pago en el paso que corresponda. */
  abrirProntoPago(paso: PasoProntoPago): void {
    this.pasoInicialProntoPago = paso;
    this.activarPestana(5);
  }

  /** El usuario terminó el flujo: vuelve a "Plan de pago". */
  volverDesdeProntoPago(): void {
    this.activarPestana(1);
  }

  /**
   * `app-tab-menu-restitucion` mantiene el resaltado en su propio estado `active`, así que al
   * cambiar de pestaña por código hay que sincronizarlo a mano.
   */
  private activarPestana(id: number): void {
    this.dataTabMenu.forEach((item: any) => item.active = (item.id === id));
    this.tabView_index = id;
    this.viewBanneer = (id !== 0);
    this.ref.detectChanges();
  }

  ingresarUsuarioBifurcacion(context:any) {
    if(context === 'afiliado') {
      window.open('https://www.colmena.cl/afiliados/#/login', '_blank');
    }
    if(context === 'no-afiliado') {
      this.tabView_index = 0;
    }
  }
}
